import { Alerts } from '../Alerts.js';

angular
	.module('logbook')
	.directive('alertSelector', ['$http', '$q', '$timeout',
		function($http, $q, $timeout)
		{
			return {
				restrict: 'E',
				template: require('./alert-selector.html'),
				scope: {
					onBind: '=',
					selectedLog: '=',
					onSelection: '=',
					onEdit: '=',
					onAddAlert: '=',
					queryParams: '=',
					filter: '='
				},

				link: function(scope, elem, attrs)
				{
					
					scope.typeahead = {
						timeoutId: undefined
					};
					
					scope.map = {};
					scope.filteredMap = {};
					
					var $element = $(elem);
					var $searchInput = $(elem).find('#input-alert-search')
						.keypress(function(e)
						{
							if (e.keyCode === 13)
								scope.search($(this).val());
						})
						.on('input', function()
						{
							if (!isNaN(parseInt(scope.typeahead.timeoutId)))
							{
								window.clearTimeout(scope.typeahead.timeoutId);
							}
							scope.typeahead.timeoutId = window.setTimeout(scope.searchFromInput, 600);
						});
					
					scope.searchFromInput = function()
					{
						scope.search($searchInput.val());
					};
					
					$(elem).find('#btn-alert-search').click(scope.searchFromInput);

					$(elem).find('#btn-add-alert').click(function()
					{
						if (typeof scope.onAddAlert === 'function')
							scope.onAddAlert(scope);
					});

					scope.editMode = attrs.hasOwnProperty('editMode');
					scope.addAlertEnabled = attrs.hasOwnProperty('editMode') && typeof scope.onAddAlert === 'function';

					scope.isLoading = false;
					scope.useLocal = true;
					scope.filtered = [];
					scope.originalAlerts = [];

					scope.search = function(toSearch)
					{
						if (!isNaN(parseInt(scope.typeahead.timeoutId)))
						{
							window.clearTimeout(scope.typeahead.timeoutId);
						}
						
						if (!(scope.selectedLog && scope.selectedLog.hasOwnProperty('id')))
						{
							console.log('Selected Log not set. Canceling Alert Search.');
							return;
						}

						var baseParams = {
							isDraft: false,
							activeRevision: true
						};
						
						var parameters = scope.queryParams ? Object.assign(baseParams, scope.queryParams) : baseParams;
						parameters.log = scope.selectedLog.id;
						parameters.sort = 'created,asc';
						
						if (typeof toSearch === 'string' && toSearch.length)
							parameters.name = '%' + toSearch + '%';
						
						$searchInput.val(toSearch);
						return scope.setResults(parameters);
					};

					scope.setResults = function(parameters)
					{
						parameters.saveInProgress = false;
						return $timeout(function()
						{
							scope.isLoading = true;

						}).then(function()
						{
							return $http.get('/api/alerts', {
								params: parameters,
								noLoadingIndicator: true
							})
								.then(function(results)
								{
									scope.map = {};
									scope.originalAlerts = results.data._embedded.alerts.map(function(returned)
									{
										Alerts.createAlert(scope.selectedLog.id, returned);
										scope.map[returned.complexObject.id] = returned;
										return returned;
									});
								})
								.then(function()
								{
									if (!scope.editMode)
										return;
									
									parameters.isDraft = true;
									delete parameters.activeRevision;
									
									return $http.get('/api/alerts', {
										params: parameters,
										noLoadingIndicator: true
									})
										.then(function(results)
										{
											results.data._embedded.alerts.forEach(function(alert)
											{
												alert.hasDraft = true;
												if (!scope.map[alert.complexObject.id])
													scope.originalAlerts.push(alert);
												
												scope.map[alert.complexObject.id] = alert;
											});
											
											for (var i = 0; i < scope.originalAlerts.length; i++)
											{
												scope.originalAlerts[i] = scope.map[scope.originalAlerts[i].complexObject.id];
											}
										})
								})
								.finally(function()
								{
									scope.isLoading = false;
								});
						});
					};

					if (typeof scope.onBind === 'function')
						scope.onBind(scope);
					
					scope.getAlerts = function(filtered)
					{
						let alerts = Object.keys(scope.map).reduce(function(arr, current)
						{
							if (!filtered || typeof scope.filter !== 'function')
								arr.push(scope.map[current]);
							
							else if (filtered && scope.filter(scope.map[current]))
								arr.push(scope.map[current]);
							
							return arr;
						}, []);
						
						alerts.sort((a1, a2) => {
							if (a1.name > a2.name)
								return 1;
							else if (a1.name < a2.name)
								return -1;
							else
								return 0;
						});
						
						return alerts;
					};

					scope.selectionMade = function(alert)
					{
						Alerts.createAlert(scope.selectedLog.id, alert);
						if (typeof scope.onSelection === 'function')
						{
							scope.onSelection(alert);
						}
					};
					
					scope.editSelectionMade = function(alert, fromVersionMgr)
					{
						Alerts.createAlert(scope.selectedLog.id, alert);
						fromVersionMgr = !!fromVersionMgr;
						
						if (typeof scope.onEdit === 'function')
						{
							scope.onEdit(alert, fromVersionMgr)
						}
						else if (!scope.preventSelectionFallover)
							scope.selectionMade(alert)
					};

					scope.deleteAlert = function(alert)
					{
						return $http.delete(alert.complexObject._links.self.href)
							.then(function()
							{
								delete scope.map[alert.complexObject.id];
							})
					};

					scope.applyFilter = function()
					{
						scope.filtered = (typeof scope.filter === 'function')
							? scope.originalAlerts.filter(scope.filter)
							: scope.originalAlerts;
						
						
						return scope.filtered;
					};
					
					scope.showDetailAlertModal = function(isShowing)
					{
						var command = (typeof isShowing === 'boolean')
							? (isShowing)
								? 'show'
								: 'hide'
							: 'toggle';
						
						$($element).find('#modal-alert-triggers').modal(command);
					};
					
					scope.getAlertTriggers = function(alert)
					{
						alert.reportAlertTriggers = [];
						
						scope.loadingAlertTriggers = true;
						var params = {
							'alertObject.id': alert.complexObject.id,
							'report.activeRevision': true,
							sort: 'created,desc',
							projection: 'reportAlertTriggerProjectionWithReportTemplates'
						};
						
						$http.get('/api/reportAlertTriggers', { params: params })
							.then(function(results)
							{
								alert.reportAlertTriggers = results.data._embedded.reportAlertTriggers;
							})
					};
					
					scope.setDetailMode = function(alert, enabled, type)
					{
						if (!alert || !(type === 'triggers' || type === 'history'))
							return;
						
						alert.detailMode = (typeof enabled === 'boolean') ? enabled : !alert.detailMode;
						if (alert.detailMode)
						{
							alert.view = type;
							scope.getAlertTriggers(alert);
						}
					};
					
					scope.complexManagerBound = function(cpxScope)
					{
						var alert = cpxScope.complexObject;
						
						function changesMadeCallBack(newAlert)
						{
							Alerts.createAlert(scope.selectedLog.id, newAlert);
							
							// Carry over hash key to not have list reset
							newAlert.$$hashKey = alert.$$hashKey;
							newAlert.detailMode = true;
							newAlert.view = 'history';
							scope.map[cpxScope.complexObject.complexObject.id] = alert = newAlert;
						};
						
						cpxScope.addEditCallback(function(alert)
						{
							scope.editSelectionMade(alert, true);
						});
						
						cpxScope.addRevisionMadeActiveCallback(changesMadeCallBack);
						cpxScope.addDeleteCallback(changesMadeCallBack);
						cpxScope.addOnComplexObjectChangedCallback(function(newAlert, oldAlert)
						{
							if (!newAlert || !oldAlert || (newAlert.id === oldAlert.id))
								return;
							
							changesMadeCallBack(newAlert);
						});
						
						cpxScope.addOnCloseCallback(function()
						{
							delete alert.detailMode;
							delete alert.view;
							cpxScope.complexObject.hasDraft = !cpxScope.complexObject.published
						})
					};

					scope.search();

					scope.$emit('alertSelectorReady', scope);

					Object.keys(attrs.$attr).forEach(function(key)
					{
						$element.find('#alert-selector-parent').attr(key, attrs[key]);
					});
				}
			}
		}]);